export const POST_ADD_USER_REQUEST = "POST_ADD_USER_REQUEST";
export const POST_ADD_USER_ERROR = "POST_ADD_USER_ERROR";
export const POST_ADD_USER_SUCCESS = "POST_ADD_USER_SUCCESS";
